(ns teamoesterreich.admin-mode.lebensretter.detail.jku-linz-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            ))

(defn form [!jkuLinz jkuLinzActive]
  [mui/box {:sx {:display "grid" :gridTemplateColumns "1fr 1fr" :gap "1rem"}}
   [:h3 {:style {:grid-column "span 2"}} "Sonderalarmierung JKU Linz"]
   [mui/form-control-label
    {
     :style   {:background-color (if (not= jkuLinzActive @!jkuLinz) "#ffd6d2" "transparent")
               :grid-column      "span 2"}
     :label   "Berechtigt"
     :control (r/as-element
                [mui/checkbox {:color    "primary"
                               :checked  (or @!jkuLinz false)
                               :onChange (fn [_ val]
                                           (reset! !jkuLinz val))
                               }])
     }
    ]
   ])

